module.exports = require('../../es/string/repeat');



//////////////////
// WEBPACK FOOTER
// ./~/@firebase/polyfill/~/core-js/features/string/repeat.js
// module id = 243
// module chunks = 1